import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicSearchErrorBaseComponent } from '@ups/xplat/dynamic-render';

/**
 * Presentational, non-blocking search-failure notice for dynamic typeahead controls.
 *
 * Renders only when `show` is true (each typeahead binds its inherited `searchError`
 * getter, which is backed by the control's `hasSearchError_dynamic` flag). This
 * component touches no form control, so it never invalidates the form, submit
 * blocking stays the separate, default-off `blockSubmitOnSearchFailure` opt-in.
 * Its whole job is to let a user tell a failed lookup apart from an empty result set,
 * closing the gap documented in frontend-dynamic-controls.md §3.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-search-error',
  templateUrl: './dynamic-search-error.component.html',
  standalone: false,
})
export class DynamicSearchErrorComponent extends DynamicSearchErrorBaseComponent {}
